import { BillingUseCase } from '../../../data/usecases/billing'
import { makeAxiosHttpClient } from '../../factories'

export const fetchPeriods = () => {
  return new BillingUseCase('/credito-consumo/periodos', makeAxiosHttpClient())
}
export const fetchConsumption = (period: any) => {
  if (period === '')
    return new BillingUseCase('/credito-consumo', makeAxiosHttpClient())
  else
    return new BillingUseCase(
      `/credito-consumo?period=${period}`,
      makeAxiosHttpClient()
    )
}
